var vec3 = require('@antv/gl-matrix/lib/gl-matrix/vec3');

module.exports = vec3;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/matrix/vec3.js
// module id = 12
// module chunks = 0